import { Component, Prop, Vue } from 'vue-property-decorator';
import { Select as FormSelect } from '@/components/form';
import { NAME_DEFAULT } from './const';
import { Events } from './enums';
import { Option, Options } from './types';

@Component({
  components: { FormSelect },
})
export default class PartCatalogListCount extends Vue {
  // Props
  @Prop({ type: String, default: NAME_DEFAULT })
  name: string;

  @Prop({ type: Array, required: true })
  options: Options;

  @Prop({ type: String, default: '' })
  text: string;

  @Prop({ type: [String, Number], required: true })
  value: Option;

  // Computed
  get hasText() {
    return this.text.length > 0;
  }

  get placeholder() {
    return String(this.value);
  }

  // Methods
  onInput(value: Option) {
    this.$emit(Events.CHANGE, value);
  }  
}



// WEBPACK FOOTER //
// ./src/components/parts/catalog/list/count/script.ts